// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3sgYZ","productName":"Table_productName__1I6PA"};